const initialState = {
  isOpen: false,
  guide: [],
  id: '',
  markers: [],
  guidebook: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_GUIDEBOOK': {
      const guidebook = { ...action.guidebook };
      return { ...state, guidebook };
    }
    case 'ADD_GUIDE_MARKER': {
      const marker = { ...action.marker };
      const markers = [...state.markers, marker];
      return { ...state, markers };
    }
    case 'OPEN_GUIDE': {
      const { id } = action;

      return {
        ...state,
        markers: [],
        isOpen: true,
        id,
        guide: state.guidebook[id],
      };
    }
    case 'CLOSE_GUIDE':
    case 'CLEAR': {
      const { guidebook } = state;
      return { ...initialState, guidebook };
    }
    default:
      return state;
  }
};
